import type { Deleted } from "./api";
import { callTime } from "./calls";
import { memberName } from "./memberNames";

export const REASON_MIN = 3;
export const REASON_MAX = 200;
export const UNDO_MS = 10_000;

export type Kind = "lead" | "account";

export function reasonProblem(reason: string): string | null {
  const text = reason.trim();
  if (text.length < REASON_MIN) return `Give a reason of ${REASON_MIN} characters or more.`;
  if (text.length > REASON_MAX) return `Give a reason of ${REASON_MAX} characters or fewer.`;
  return null;
}

/** A permanent delete needs the name, or the account number, typed again. */
export function confirmMatches(typed: string, ...names: string[]): boolean {
  const clean = (text: string) => text.split(/\s+/).filter(Boolean).join(" ").toLocaleLowerCase();
  const wanted = clean(typed);
  return wanted !== "" && names.some((name) => clean(name) === wanted);
}

export function deletedText(kind: Kind, deleted: Deleted, timeZone: string): string {
  const by = deleted.by ? memberName(deleted.by) : "a removed member";
  const reason = deleted.reason.trim().replace(/[.!?]+$/, "");
  return `This ${kind} was deleted on ${callTime(deleted.at, timeZone)} by ${by}. Reason: ${reason}. It does not show in the lists.`;
}

export function deletedTitle(deleted: Deleted, timeZone: string): string {
  return `Deleted ${callTime(deleted.at, timeZone)}: ${deleted.reason}`;
}
